module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00684.323eaf87.jpg";